module.exports = __webpack_public_path__ + "img/ch-1.e073af98.jpg";